import View from './View';
import CoverSchema from './schema';
import icon from '@plone/volto/icons/hero.svg';

const CoverBlock = {
    id: 'cover',
    title: 'Cover',
    view: View,
    icon: icon,
    group: 'wildcard',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    blockSchema: CoverSchema,
};

export default CoverBlock;